import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "go-to-component" }
const _hoisted_2 = { class: "go-to-component__go-to" }
const _hoisted_3 = { class: "go-to-component__content" }
const _hoisted_4 = { class: "go-to-component__transition-picker" }
const _hoisted_5 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_7 = {
  key: 0,
  class: "invalid-warning"
}

import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import TagBox from '@/shared/components/TagBox.vue';
import { required } from '@vuelidate/validators';
import { StateViewModel } from '@/features/bots/models/designer/stateViewModel';
import IslandBadge from './IslandBadge.vue';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import { computed, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'GoToComponent',
  props: {
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
},
  emits: ["state-updated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = ref<StateViewModel>({
  id: '',
  component: 'GoTo',
});
const invalid = ref(true);

const validations = {
  state: {
    transition: {
      required,
      type: {
        required,
      },
      payload: {
        payloadValid(payload: string) {
          if (payload) {
            return !isTransitionPayloadInvalid(payload).value;
          }
          return true;
        },
      },
    },
  },
};

const $v = useVuelidate(validations, { state });
const isRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.state.transition));
const isPayloadInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.state.transition, 'payloadValid'),
);

const store = useStore();
const isTransitionPayloadInvalid = (payload: string) =>
  computed(() => store.getters.isTransitionPayloadInvalid(payload));

onMounted(() => {
  if (props.value) {
    state.value = props.value;
    invalid.value = state.value.invalid ?? false;
  }
});

function updateTransition(transition: TransitionViewModel) {
  state.value.transition = transition;
  emitUpdatedEvent();
}

function validateGoTo() {
  $v.value.state.$touch();
}

function emitUpdatedEvent() {
  invalid.value = $v.value.state.transition.$invalid;
  state.value.invalid = invalid.value;
  emit('state-updated', state.value);
}

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IslandBadge, {
      type: "goto",
      draggable: false
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TagBox, { value: "go to" }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TransitionPicker, {
            transition: state.value.transition,
            onTransitionSelected: updateTransition,
            "show-none-transition": false
          }, null, 8, ["transition"]),
          (isPayloadInvalid.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Must not contain an invalid transition"))
            : (isRequiredInvalid.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Must select a transition"))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    (invalid.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(ErrorIcon, { class: "icon-1-3x" })
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_away, validateGoTo]
  ])
}
}

})